export default __webpack_public_path__ + "static/media/Fist of Siptah.23b64cd8.jpg";